import React, { useEffect } from 'react';
import up from '../assets/Union.svg';
import '../styles/SearchBar.css';

export default function SearchBar({
  startDate,
  setStartDate,
  departureFrom,
  setDepartureFrom,
  adults,
  setAdults,
  children,
  setChildren,
  rooms,
  setRooms,
  totalGuests,
  setTotalGuests,
  onUpdateTour,  
  tourId, 
}) {
  // Keep syncing totalGuests when adults or children change
  useEffect(() => {
    setTotalGuests(adults + children);
  }, [adults, children, setTotalGuests]);

  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const handleUpdateTour = async () => {
    const baseUrl = "http://localhost:8081"; // replace with actual base URL
    // Use tourId from props instead of hardcoded value
    if (!tourId) {
      console.error("tourId prop is missing!");
      return;
    }
    const url = `${baseUrl}/api/tour/${tourId}/overview?start_date=${startDate}&total_guests=${totalGuests}&include_flight=true`;

    console.log("url from search bar:", url);
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('Failed to fetch tour overview');
      const data = await res.json();

      if (onUpdateTour) {
        onUpdateTour(data);
      }
    } catch (error) {
      console.error("Update Tour API error:", error);
    }
  };

  return (
    <div
      style={{
        margin: '20px',
        padding: '20px',
        borderRadius: '12px',
        backgroundColor: '#fff',
        display: 'flex',
        gap: '20px',
        flexWrap: 'wrap',
      }}
      className="tour-search-search-bar"
    >
      {/* Starting Date */}
      <div className="tour-search-input-group">
        <div className="tour-search-input-label">Starting Date</div>
        <div className="tour-search-input tour-search-date-input" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            
            style={{
              backgroundColor: '#FBF4FF',
              border: 'none',
              padding: '10px',
              paddingRight: '35px'
            }}
          />
          <img
            src={up}
            alt="calendar"
            style={{
              position: 'absolute',
              right: '10px',
              width: '20px',
              pointerEvents: 'none'
            }}
          />
        </div>
      </div>

      {/* Departure */}
      <div className="tour-search-input-group">
        <div className="tour-search-input-label">Departure</div>
        <input
          type="text"
          value={departureFrom}
          onChange={(e) => setDepartureFrom(e.target.value)}
          className="tour-search-input"
          style={{
            backgroundColor: '#FBF4FF',
            borderRadius: '6px',
            border: '1px solid #ccc',
            padding: '10px',
          }}
          placeholder="Departure from"
        />
      </div>

      {/* Guests & Rooms */}
      <div className="tour-search-input-group" style={{ position: 'relative' }}>
        <div className="tour-search-input-label">Guests</div>
        <div
          className="tour-search-total-member"
          onClick={() => setDropdownOpen(!dropdownOpen)}
          style={{
            backgroundColor: '#FBF4FF',
            cursor: 'pointer',
            padding: '10px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            minWidth: '250px',
          }}
        >
          <div>{adults} Adults and {children} Children</div>
          <img src={up}></img>
        </div>

        {/* Dropdown */}
        {dropdownOpen && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              backgroundColor: '#fff',
              boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
              padding: '12px',
              borderRadius: '8px',
              zIndex: 10,
              marginTop: '8px',
              width: '260px',
            }}
          >
            {[
              { label: 'Adults', value: adults, setter: setAdults, min: 1 },
              { label: 'Children', value: children, setter: setChildren, min: 0 },
              { label: 'Rooms', value: rooms, setter: setRooms, min: 1 },
            ].map(({ label, value, setter, min }) => (
              <div
                key={label}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '10px',
                }}
              >
                <label style={{ fontWeight: '500', marginRight: '10px', fontSize: '18px', borderRadius: '20px' }}>{label}</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div
                    onClick={() => setter(value + 1)}
                    className='changeNumButton'
                    style={{ borderTopLeftRadius: '20px', borderBottomLeftRadius: '20px', cursor: 'pointer' }}
                  >
                    +
                  </div>
                  <div className='changeNumInput'>{value}</div>
                  <div
                    onClick={() => setter(Math.max(min, value - 1))}
                    className='changeNumButton'
                    style={{ borderTopRightRadius: '20px', borderBottomRightRadius: '20px', cursor: 'pointer' }}
                  >
                    -
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Update Button */}
      <div style={{ alignSelf: 'flex-end' }}>
        <button className="tour-search-update-btn" onClick={handleUpdateTour}>Update Tour</button>
      </div>
    </div>
  );
}
